import Service from './Service';
import Storage from '../storage';

class AuthService extends Service {
  signIn(credentials) {
    const self = this;
    const promise = new Promise(async (resolve, reject) => {
      try {
        const response = await self.fetchApi().post('auth/login', {
          usuario: credentials.username,
          password: credentials.password,
        });
        const { data: { token, refreshToken, ...user } } = response;
        if (token) Storage.saveToken(token);
        if (refreshToken) Storage.saveRefresToken(refreshToken);
        if (user) Storage.saveUser(user);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }

  signInMSAL(tokenId) {
    const self = this;
    const promise = new Promise(async (resolve, reject) => {
      try {
        const response = await self.fetchApi().post('auth/login-azure', {
          token: tokenId
        });
        const { data: { token, refreshToken, ...user } } = response;
        if (token) Storage.saveToken(token);
        if (refreshToken) Storage.saveRefresToken(refreshToken);
        if (user) Storage.saveUser(user);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }

  signOut() {
    Storage.cleanStorage();
  }
}

export default AuthService;
